module.exports = __webpack_public_path__ + "static/media/adsTxt.30e52a8d.svg";